import { BeneficiaryDetailsClient } from "../../../../../../../../Wrap/Api/Account/BeneficiaryDetails";
import { ValidationStatus } from "../../../../../../../../Wrap/Core/Web/Validation/ValidationStatus";
import { Beneficiary } from "../../../../../../../../Wrap/Models/Domains/Beneficiary/Beneficiary";

export class ProductOverviewSippBeneficiariesAction {
    public static get(hierarchyId: string, callback) {
        const client = new BeneficiaryDetailsClient();
        const promise = client.get(hierarchyId);

        promise.onSuccess((data) => {
            callback(data);
        });

        promise.onError(() => {});
    }

    public static put(hierarchyId, beneficiaries: Array<Beneficiary>, callBack?: (val: ValidationStatus) => void) {
        const client = new BeneficiaryDetailsClient();
        const promise = client.post(beneficiaries, hierarchyId);

        promise.onSuccess((data) => {
            if (callBack) {
                callBack(data);
            }
        });

        promise.onError(() => {});
    }
}
